import React from 'react';

export const stopPropagation = <H extends HTMLElement = HTMLElement>(
  event: React.MouseEvent<H> | MouseEvent,
) => {
  event.stopPropagation();
};

export default stopPropagation;
